import React from "react";
import { BookOpen, CalendarDays, Map, ShoppingBag } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { path: "/mapa", label: "Mapa", icon: Map },
  { path: "/calendario", label: "Agenda", icon: CalendarDays },
  { path: "/directorio", label: "Directorio", icon: ShoppingBag },
  { path: "/conocimiento", label: "Saberes vivos", icon: BookOpen },
];

export default function Navigation() {
  const location = useLocation();

  return (
    <nav className="platform-top-chrome border-b border-border shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center gap-2">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-2 border-b-2 px-6 py-4 text-sm font-medium transition-colors ${
                  isActive
                    ? "border-primary text-primary"
                    : "border-transparent text-mutedForeground hover:border-border hover:text-primary"
                }`}
              >
                <Icon className="h-5 w-5" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
